import { render, staticRenderFns } from "./CardSidebarTabAttachments.vue?vue&type=template&id=6bf22c3d"
import script from "./CardSidebarTabAttachments.vue?vue&type=script&lang=js"
export * from "./CardSidebarTabAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports